import { cn } from '@lib/utils';
import { useGetMeiaAcrRegister } from '@queries/meia.query';
import { ShieldAlertIcon } from 'lucide-react';
import type { FC } from 'react';
import { getAcrG4Blocked, getAcrOpenCount } from './meia-acr.util';

type MeiaAcrShieldProps = {
  onOpen: () => void;
  studyId: string;
};

export const MeiaAcrShield: FC<MeiaAcrShieldProps> = (props) => {
  const { onOpen, studyId } = props;
  const { data: entries = [] } = useGetMeiaAcrRegister({ studyId });

  const openCount = getAcrOpenCount(entries);
  const isBlocked = getAcrG4Blocked(entries);

  return (
    <button
      aria-label={`ACR Register — ${openCount} open ${openCount === 1 ? 'item' : 'items'}${
        isBlocked ? ', sign-off blocked' : ''
      }`}
      className={cn(
        'relative inline-flex cursor-pointer items-center gap-1.5 rounded-md border bg-white px-3 py-1.5 text-xs transition-colors',
        isBlocked
          ? 'border-red-300 text-red-700 hover:border-red-400'
          : 'border-gray-200 text-gray-500 hover:border-gray-300 hover:text-gray-700',
      )}
      onClick={onOpen}
      type="button"
    >
      <ShieldAlertIcon className="size-4 text-red-600" />
      <span className="font-medium tabular-nums">{openCount}</span>
      {isBlocked && <span className="absolute -right-0.5 -top-0.5 size-2 rounded-full bg-red-600" />}
    </button>
  );
};
